import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Llegás a la cancha sin saber exactamente qué ejercicios o progresión vas a trabajar hoy', 'Tus alumnos no progresan porque no tenés una estructura clara de nivel a nivel', 'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos drills de siempre porque no tenés más material organizado y listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnos de distintos niveles en el mismo grupo y la clase se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque la comunicación con ellos es inconsistente'];
  return <section className="py-12 md:py-20 bg-white" data-id="element-189">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-191">
          <h2 className="text-2xl md:text-4xl font-display text-navy-900 mb-3 md:mb-4" data-id="element-192">
            Si sos entrenador o entrenadora de tenis en Argentina,{' '}
            <span className="text-terracotta" data-id="element-193">
              esto te va a sonar familiar:
            </span>
          </h2>
          <div className="w-16 md:w-24 h-1 bg-terracotta mx-auto" data-id="element-194"></div>
        </motion.div>

        <div className="space-y-2.5 md:space-y-4 mb-8 md:mb-12" data-id="element-195">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-red-50/50 border border-red-100" data-id="element-196">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-197" />
              <p className="text-sm md:text-lg text-gray-800 font-medium" data-id="element-198">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-navy-900 text-white p-5 md:p-8 rounded-2xl shadow-xl" data-id="element-199">
          <h3 className="text-xl md:text-3xl font-display text-optic uppercase tracking-wide" data-id="element-200">
            ¿Cuántas clases más vas a improvisar?
          </h3>
        </motion.div>
      </div>
    </section>;
}